import { SiteHeader } from "@/components/site-header";
import { ClientsTable } from "./ClientsTable";

export default function ClientsPage() {
  return (
    <>
      <SiteHeader title="Clientes" />
      <div className="flex flex-1 flex-col px-4 py-6 lg:px-6">
        <ClientsTable />
      </div>
    </>
  );
}
